import { STATUSES } from '@/const/status'
import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  namespaced: true,
  state: {
    statuses: STATUSES,
    certificateImplements: [],
    totalRows: 0,
    certificateImplement: [],
  },
  getters: {
    statuses: state => state.statuses,
    certificateImplements: state => state.certificateImplements,
    totalRows: state => state.totalRows,
    certificateImplement: state => state.certificateImplement,
  },
  mutations: {
    SET_STATUSES: (state, statuses) => {
      state.statuses = statuses
    },
    SET_CERTIFICATE_IMPLEMENTS: (state, certificateImplements) => {
      state.certificateImplements = certificateImplements
    },
    SET_TOTAL_ROWS: (state, data) => {
      state.totalRows = data
    },
    SET_CERTIFICATE_IMPLEMENT: (state, certificateImplement) => {
      state.certificateImplement = certificateImplement
    },
  },
  actions: {
    async readCertificateImplements({ commit }, params) {
      try {
        const response = await axios.get('certificates/certificate_implements', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_CERTIFICATE_IMPLEMENTS', records)
          commit('SET_TOTAL_ROWS', total)
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },

    async createCertificateImplement({ commit }, params) {
      try {
        const response = await axios.post('certificates/certificate_implements', params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async updateCertificateImplement({ commit }, params) {
      try {
        const response = await axios.put(`certificates/certificate_implements/${params.id}`, params)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async deleteCertificateImplement({ commit }, id) {
      try {
        const response = await axios.delete(`certificates/certificate_implements/${id}`)
        const { data } = response
        return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
    async getCertificateImplement({ commit }, params) {
      try {
        const response = await axios.get('certificates/certificate_implements', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { total, records } = data.data
          commit('SET_CERTIFICATE_IMPLEMENT', records)
        }
      } catch (e) {
        handleCatch(e)
      }
      return null
    },
  },
}
